export const selectOutreachesLoading = (state) => state?.outreaches?.isLoading;
export const selectOutreaches = (state) => state?.outreaches?.data;

export const selectOutreachesFilterOptions = (state) =>
  state?.outreaches?.filters;
export const selectOutreachesSearchTerm = (state) =>
  state?.outreaches?.search?.term;
export const selectOutreachesFilterChanged = (state) =>
  state?.outreaches?.filters?.changed;

export const selectOutreachesSearchOptions = (state) =>
  state?.outreaches?.search;
export const selectOutreachesSortOptions = (state) => state?.outreaches?.sort;

export const selectOutreachesListLoading = (state) =>
  state?.outreaches?.isOutreachListLoading;
export const selectOutreachesList = (state) => state?.outreaches?.outreachList;

export const selectOutreachesAddableListLoading = (state) =>
  state?.outreaches?.isOutreachAddableListLoading;
export const selectOutreachesAddableList = (state) =>
  state?.outreaches?.outreachAddableList;

export const selectOutreachesListAllLoading = (state) =>
  state?.outreaches?.isOutreachListAllLoading;
export const selectOutreachesListAll = (state) =>
  state?.outreaches?.outreachListAll;

export const selectOutreachesUserSenderLoading = (state) =>
  state?.outreaches?.isoutreachUserSenderLoading;
export const selectOutreachesUserSender = (state) =>
  state?.outreaches?.outreachUserSender;

export const selectUserChangedFilter = (state) =>
  state?.outreaches?.filters?.changed || state?.outreaches?.search?.term;
